import config from 'config'

import { CredentialsFragment } from 'gqlTypes'

const SECONDS_TO_MILLISECONDS = 1000

const SIGN_IN_ENDPOINT = config.graphql_api_domain.replace(
  '/api',
  '/oauth/token'
)

const SIGN_IN_WITH_SSO_ENDPOINT = config.graphql_api_domain.replace(
  '/api',
  '/sso/token'
)
const REVOKE_OAUTH_ENDPOINT = config.graphql_api_domain.replace(
  '/api',
  '/oauth/revoke'
)

export const getSignInEndpoint = () => SIGN_IN_ENDPOINT
export const getSignInWithSsoEndpoint = () => SIGN_IN_WITH_SSO_ENDPOINT
export const getRevokeOAuthEndpoint = () => REVOKE_OAUTH_ENDPOINT

export const createExpireDate = (duration: number) =>
  new Date(Date.now() + duration * SECONDS_TO_MILLISECONDS).toISOString()

export const formatAuthorizationHeader = (
  credentials: CredentialsFragment | undefined | null
) => {
  return credentials ? `bearer ${credentials.authToken}` : null
}
